import React, { useCallback } from 'react';
import { useViewModel } from "mvvm/View";
import { JobViewModel } from "../ViewModels/JobViewModel";
import { useAppSelector, useDarkMode } from "redux/hooks";

export function StreamContextMenuView(props: {
    model: JobViewModel,
    contextMenu: { visible: boolean, x: number, y: number },
    setContextMenu: React.Dispatch<React.SetStateAction<{ visible: boolean, x: number, y: number }>>,
    contextMenuRef: React.RefObject<HTMLDivElement>,
    onRename: () => void,
    onEdit?: () => void,
    onRegenerate?: () => void
}) {
    const darkMode = useDarkMode();
    const model = useViewModel(props.model);
    const contextMenu = props.contextMenu;
    const setContextMenu = props.setContextMenu;
    const contextMenuRef = props.contextMenuRef;

    const handleContextMenuClickEdit = useCallback(() => {
        setContextMenu({ visible: false, x: 0, y: 0 });
        props.onEdit?.();
    }, [setContextMenu, props]);

    const handleContextMenuClickRename = useCallback(() => {
        setContextMenu({ visible: false, x: 0, y: 0 });
        props.onRename();
    }, [setContextMenu, props]);

    const handleContextMenuClickRegenerate = useCallback(() => {
        setContextMenu({ visible: false, x: 0, y: 0 });
        props.onRegenerate?.();
    }, [setContextMenu, props]);

    const handleContextMenuClickDelete = useCallback(() => {
        model.deleteJob();
        setContextMenu({ visible: false, x: 0, y: 0 });
    }, [model, setContextMenu]);

    if (!contextMenu.visible) {
        return null;
    }

    return (
        <div
            ref={contextMenuRef}
            className='context-menu'
            tabIndex={-1}
            style={{
                position: 'fixed',
                top: contextMenu.y,
                left: contextMenu.x,
                border: darkMode ? 'none' : undefined
            }}
        >
            {props.onRegenerate && (
                <button className='context-menu-item' onClick={handleContextMenuClickRegenerate}>Regenerate Dashboard</button>
            )}
            {(props.onRegenerate || props.onEdit) && (
                    <div className='context-menu-separator' />
            )}
            {props.onEdit && (
                <button className='context-menu-item' onClick={handleContextMenuClickEdit}>Edit Dashboard</button>
            )}
            <button className='context-menu-item' onClick={handleContextMenuClickRename}>Rename Dashboard</button>
            <div className='context-menu-separator' />
            <button className='context-menu-item' onClick={handleContextMenuClickDelete}>Delete Dashboard</button>
        </div>
    );
}